
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M46 10a4 4 0 014 4v36a4 4 0 01-4 4H18a4 4 0 01-4-4V14a4 4 0 014-4h28zm2 10H16v30a2 2 0 001.767 1.987L18 52h28a2 2 0 001.987-1.767L48 50V20zm-6 4a2 2 0 012 2v20a2 2 0 01-2 2H22a2 2 0 01-2-2V26a2 2 0 012-2h20zm0 2H22v20h20V26zm-11.428 4.502a1 1 0 01.101 1.277l-.117.137-.868.849a1.778 1.778 0 00.008 2.514 3.853 3.853 0 01.28 5.156l-.231.26-1.027 1.06a1 1 0 01-1.55-1.253l.114-.14 1.028-1.059c.648-.668.693-1.699.141-2.417l-.165-.188a3.779 3.779 0 01-.248-5.088l.27-.294.85-.83a1 1 0 011.414.016zm6 0a1 1 0 01.101 1.277l-.117.137-.868.849a1.778 1.778 0 00.008 2.514 3.853 3.853 0 01.28 5.156l-.231.26-1.027 1.06a1 1 0 01-1.55-1.253l.114-.14 1.028-1.059c.648-.668.693-1.699.141-2.417l-.165-.188a3.779 3.779 0 01-.248-5.088l.27-.294.85-.83a1 1 0 011.414.016zM46 12H18a2 2 0 00-1.987 1.767L16 14v4h32v-4a2 2 0 00-1.767-1.987L46 12zm-25 2a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm10 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    